import { render, staticRenderFns } from "./PowerupSearchEditComponent.vue?vue&type=template&id=5dbc6056&scoped=true"
import script from "./PowerupSearchEditComponent.vue?vue&type=script&lang=ts"
export * from "./PowerupSearchEditComponent.vue?vue&type=script&lang=ts"
import style0 from "./PowerupSearchEditComponent.vue?vue&type=style&index=0&id=5dbc6056&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dbc6056",
  null
  
)

export default component.exports